import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=30a2b34c"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a2b34c')) {
      api.createRecord('30a2b34c', component.options)
    } else {
      api.reload('30a2b34c', component.options)
    }
    module.hot.accept("./LoginModal.vue?vue&type=template&id=30a2b34c", function () {
      api.rerender('30a2b34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/LoginModal.vue"
export default component.exports